module.exports = __webpack_public_path__ + "public/img/manajemen sumber daya manusia untuk pegawai personalia-2.43ba4af3.png";